module.exports = __webpack_public_path__ + "img/faq3.60bf3f4b.png";